import { Injectable } from '@angular/core';
import { Grade, PartyRoleTypes, School } from '../model/school.model';
import { PartyRolesService } from 'src/app/component/party/service/party-roles.service';
import { Region } from '../model/region.model';
import { SchoolDistrict } from '../model/schoolDistrict.model';
import { County } from '../model/county';

export interface ProgressSpinnerSet {
    progressMax: number;
    progressCurrentValue: number;
    progressValue: number;
    progressSpeed: number;
    isPdf: boolean;
}
@Injectable({
    providedIn: 'root'
})
export class UtilityService {
    constructor(private partyRolesService: PartyRolesService) {}

    promisify(fn: Function): (...args: any[]) => Promise<any> {
        return function (...args: any[]): Promise<any> {
            return new Promise((resolve, reject) => {
                fn(...args, (err: any, result: any) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(result);
                    }
                });
            });
        };
    }

    fnCalcSvcRptProgressSpeed(numSchoolsSelected: number, numRegions: number, dtsetSize: number, numCounties: number, numDistricts: number): number {
        // single vs svc code
        // schools vs none
        // if schools, how many
        let progressSpeed: number = 0.008; // default
        console.log('numSchools:');
        console.log(numSchoolsSelected);
        console.log('numRegions:');
        console.log(numRegions);
        console.log('numCounties:');
        console.log(numCounties);
        console.log('numDistricts:');
        console.log(numDistricts);
        console.log('dtsetSize:');
        console.log(dtsetSize);

        if (numSchoolsSelected > 0 && numSchoolsSelected < 50) {
            progressSpeed = dtsetSize < 20 ? 1 : 0.01;
        } else if (numRegions <= 2) {
            if (dtsetSize < 10) {
                if (numCounties <= 0 && numSchoolsSelected > 0 && numDistricts > 0) {
                    progressSpeed = 0.8;
                } else if (numCounties <= 1 && numSchoolsSelected == 0 && numDistricts == 0) {
                    progressSpeed = 1;
                } else if (numCounties > 3) {
                    progressSpeed = 0.006;
                }
            } else {
                progressSpeed = numSchoolsSelected == 0 ? 0.01 : 0.004;
            }
        } else if (numRegions > 2) {
            progressSpeed = dtsetSize < 10 ? 0.2 : 0.005;
        } else if (numSchoolsSelected >= 40) {
            progressSpeed = numCounties > 0 ? (numRegions <= 2 ? 0.05 : 0.08) : 0.006;
        } else {
            progressSpeed = 0.008;
        }

        console.log('returning progress speed: ');
        console.log(progressSpeed);
        return progressSpeed;
    }

    CreateRegionFromNumberAndRegion(num: number, reg: Region) {
        let oRegion: Region = new Region();
        oRegion.ID = num;
        oRegion.CODE = reg.CODE;
        oRegion.NAME = reg.NAME;
        oRegion.ORGANIZATIONS_ID = reg.ORGANIZATIONS_ID;
        return oRegion;
    }

    CreateRegionFromNumber(num: number) {
        let oRegion: Region = new Region();
        oRegion.ID = num;
        return oRegion;
    }

    CreateCountyFromID(num: number, cty: County) {
        let oCounty: County = new County();
        oCounty.ID = num;
        oCounty.COUNTY_CODE = cty.COUNTY_CODE;
        oCounty.COUNTY_NAME = cty.COUNTY_NAME;
        return oCounty;
    }

    CreateSchoolDistrictFromNumber(num: number) {
        let oDistrict: SchoolDistrict = new SchoolDistrict();
        oDistrict.CODE = num.toString();
        return oDistrict;
    }

    CreateCountyFromNumber(num: number) {
        let oCounty: County = new County();
        oCounty.COUNTY_CODE = num.toString();
        return oCounty;
    }

    CreateSchoolFromNumber(num: number, scl?: School): School {
        let oSchool: School = new School();

        oSchool.ID = num;
        if (scl) {
            oSchool.COUNTy = scl?.COUNTy;
            oSchool.REGION = scl?.REGION;
            oSchool.SCHOOL_CODE = scl?.SCHOOL_CODE;
            oSchool.DISTRICT = scl?.DISTRICT;
        }
        return oSchool;
    }

    fnSetProgressSpeed(rowCount: number) {
        let progressSpeedReturn: number = 0;
        if (rowCount < 500) {
            progressSpeedReturn = 100;
        } else if (rowCount > 500 && rowCount < 2000) {
            progressSpeedReturn = 200;
        } else if (rowCount > 3000 && rowCount < 7000) {
            progressSpeedReturn = 300;
        } else {
            progressSpeedReturn = 500;
        }
        return progressSpeedReturn;
    }

    fnPrepProgressSpinner(numResults: ProgressSpinnerSet) {
        console.log('initial progressmax:');
        console.log(numResults.progressMax);
        if (numResults.isPdf) {
            numResults.progressMax = numResults.progressMax * 10;
        }
        /*       if (numResults.progressMax < 10)
        {
            numResults.progressMax = 10;
            numResults.progressSpeed = 1; 
            numResults.progressValue = (1/numResults.progressMax);

        } */
        if (numResults.progressMax < 100) {
            numResults.progressMax = 50;
            numResults.progressSpeed = 1;
            numResults.progressValue = 1;
            numResults.progressCurrentValue = 1;
            numResults.progressValue = 1 / numResults.progressMax;
        } else if (numResults.progressMax < 500 && numResults.progressMax >= 100) {
            numResults.progressSpeed = 90; // because this report generates slower
            numResults.progressValue = 10;
            numResults.progressCurrentValue = 10;
            numResults.progressValue = (1 / numResults.progressMax) * 10;
        } else {
            numResults.progressSpeed = 120; // because this report generates slowest
            numResults.progressValue = 10;
            numResults.progressCurrentValue = 10;
            numResults.progressValue = (1 / numResults.progressMax) * 100;
        }
        console.log('set progressMax at:');
        console.log(numResults.progressMax);

        console.log('initial progressValue=');
        console.log(numResults.progressValue);
    }

    fnRemoveTimeStamp(strInDate: string): string {
        return strInDate.substring(0, strInDate.indexOf(' '));
    }

    fnFormatGradeSpan(lowGrades: Grade, highGrades: Grade) {
        let lowGradeDesc: string = '';
        let lowGrade: string = '';

        if (lowGrades) {
            lowGradeDesc = lowGrades.DESCRIPTION ? lowGrades.DESCRIPTION : '';
            lowGrade = lowGrades.GRADES ? lowGrades.GRADES : '';
        }
        let highGradeDesc: string = '';
        let highGrade = '';

        if (highGrades) {
            highGradeDesc = highGrades.DESCRIPTION ? highGrades.DESCRIPTION : '';
            highGrade = highGrades.GRADES ? highGrades.GRADES : '';
        }
        let retString = '';
        let strFirstPart = '';
        let strSecondPart = '';
        if (lowGrade && lowGradeDesc) {
            strFirstPart = lowGradeDesc + '(' + lowGrade + ')';
        }
        if (highGrade && highGradeDesc) {
            strSecondPart = highGradeDesc + '(' + highGrade + ')';
        }
        if (strFirstPart && strSecondPart) {
            retString = strFirstPart + ' to ' + strSecondPart;
        } else {
            if (!strFirstPart) {
                retString = ' to ' + strSecondPart;
            }
            if (!strSecondPart) {
                retString = strFirstPart;
            }
        }
        return retString;
    }

    isValidKeys(e: KeyboardEvent) {
        if (e.key) {
            let inputChar = e.key.toString();
            /*  console.log("isValidKeys")
      console.log(inputChar);
      console.log(e.metaKey)
      console.log(e.ctrlKey)*/

            if (inputChar == 'Control' || inputChar == 'V' || inputChar == 'v' || inputChar == 'X' || inputChar == 'x') {
                if (e.ctrlKey == true) {
                    return true;
                }
                return false;
            }
            if (
                inputChar == 'Tab' ||
                inputChar == 'ArrowRight' ||
                inputChar == 'ArrowLeft' ||
                inputChar == 'Backspace' ||
                inputChar == 'Delete' ||
                inputChar == '-' ||
                inputChar == ' '
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    getPartyRoleTypes(myType: string, myPartyRoleTypes: any) {
        this.partyRolesService.indexPartyRoleTypesByCategory(myType).subscribe((res) => {
            const type = myType;
            //console.log("here are all the party role types")
            // console.log(res.partyRoleTypes)
            let myPartyRoleType1: PartyRoleTypes;
            let myPartyRoleType2: PartyRoleTypes;
            myPartyRoleType1 = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                return prt.TYPE === type;
            });

            myPartyRoleType2 = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                return prt.TYPE === 'School District';
            });

            console.log('getPartyRoleTypes returning');
            console.log(myPartyRoleType1);
            console.log(myPartyRoleType2);
            myPartyRoleTypes.push(myPartyRoleType1);
            myPartyRoleTypes.push(myPartyRoleType2);
        });
    }

    getPartyRoleTypesByIndex(myType: string, myPartyRoleTypes: any, indexNumber: number): any {
        this.partyRolesService.indexPartyRoleTypesByCategory(myType).subscribe((res) => {
            const type = myType;
            //console.log("here are all the party role types")
            // console.log(res.partyRoleTypes)
            let myPartyRoleType1: PartyRoleTypes;
            let myPartyRoleType2: PartyRoleTypes;
            myPartyRoleType1 = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                // return prt.TYPE === type;
                return prt.ID == 6;
            });

            myPartyRoleType2 = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                return prt.TYPE === 'School District';
            });

            console.log('getPartyRoleTypesByIndex returning');
            console.log(myPartyRoleType1);
            console.log(myPartyRoleType2);
            if (indexNumber == 0) {
                return myPartyRoleType1;
            }
            return myPartyRoleType2;
            //      myPartyRoleTypes.push(myPartyRoleType1);
            //      myPartyRoleTypes.push(myPartyRoleType2);
        });
    }

    fnMakeDataMonFileName(strTemplateName: string, strYear: string) {
        var nowDateStamp = this.fnFormatDateTime();
        /*switch(strTemplateName)
        {
            case "MPO 1.0":
                return "MPO 1.0-Below standard AND enrolled (" + strYear + ")-" + nowDateStamp;
            default:
                return "MPO 1.0-Below standard AND enrolled (" + strYear + ")-" + nowDateStamp;
        }*/
        nowDateStamp = nowDateStamp.trimLeft();
        console.log('template_name will be:');
        console.log('_' + nowDateStamp);
        return '_' + nowDateStamp;
    }

    fnGetActualLen(myObj: any) {
        var len = 0;
        if (myObj == undefined) {
            len = 0;
        } else {
            for (var i = 0; i < myObj?.length; i++) {
                if (Object.keys(myObj[i]) !== undefined) {
                    len++;
                }
            }
        }
        return len;
    }

    fnFormatDateTime() {
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const year = now.getFullYear();

        let hours = now.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const formattedDateTime = `${month}_${day}_${year} ${hours}_${minutes} ${ampm}`;
        return formattedDateTime;
    }

    generateNewGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    isEven(num: number) {
        return num % 2 === 0;
    }

    fnDateDiff(date1: string, date2: string) {
        const dt1 = new Date(date1).getTime();
        const dt2 = new Date(date2).getTime();
        const timeDiff: number = (dt2 - dt1) / (1000 * 60 * 60 * 24);

        return timeDiff;
    }

    fnCalcDelayHideSpinner(iRowCount: number) {
        let rowCount = iRowCount;
        let delayHideSpinner = 6000; //ms
        if (rowCount > 3000) {
            delayHideSpinner = 200000;
        } else if (rowCount > 1000 && rowCount < 2999) {
            delayHideSpinner = 80000;
        }
        console.log('fnCalcDelayHideSpinner for ');
        console.log(rowCount);
        console.log('rows');
        return delayHideSpinner;
    }

    fnMakeFileName(strTemplateName: string, strSchoolYear?: string) {
        var nowDateStamp = this.fnFormatDateTime();

        nowDateStamp = nowDateStamp.trimLeft();
        nowDateStamp = this.fnRemoveTimeStamp(nowDateStamp);
        return strTemplateName + '_' + nowDateStamp;
    }

    fnMakeFileNameTime(strTemplateName: string, strSchoolYear?: string) {
        var nowDateStamp = this.fnFormatDateTime();

        nowDateStamp = nowDateStamp.trimLeft();
        return strTemplateName + '_' + nowDateStamp;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }
}
